import type { RatingType } from "../model";

export const sendRating = async (data: RatingType, dialogue_id: string) => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_AI_API_URL}/rate/${dialogue_id}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    },
  );

  const result = await response.json();
  return result;
};
